import { sdk } from '@/utils/sdk'

export const getLanguage = (): string => sdk.translation.uiTranslation.currentLanguage

export const setLanguage = (newValue: string): void => {
    sdk.translation.uiTranslation.changeCurrentLanguage(newValue),
    window.location.reload()
}
